import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { GetMultiCodeListService } from './api-services/get-multi-code-list.service';
import { KYMW4701Module } from '../kymw4701/kymw4701.module';

import { KYMW4700Component } from './kymw4700.component';

/**
 * マルチコード一覧画面 モジュール設定クラス
 *
 * @export KYMW4700Module
 * @class KYMW4700Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
    KYMW4701Module,
  ],
  declarations: [KYMW4700Component],
  providers: [GetMultiCodeListService],
})
export class KYMW4700Module {}
